import { render } from "./index.vue?vue&type=template&id=77d4d1d0&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=77d4d1d0&scoped=true&lang=css"

import exportComponent from "/Users/yuhuiliu/code/btkcode/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d4d1d0"]])

export default __exports__